import { render, staticRenderFns } from "./HistoryEdit.vue?vue&type=template&id=632c72fc&scoped=true&"
import script from "./HistoryEdit.vue?vue&type=script&lang=js&"
export * from "./HistoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632c72fc",
  null
  
)

export default component.exports